import React, { useEffect, useState } from 'react';
import { Hand, Footprints, Smile, User } from 'lucide-react';
const ACTIONS = [{
  id: 'clap',
  label: '拍手',
  icon: Hand,
  color: 'bg-red-500'
}, {
  id: 'legs',
  label: '拍腿',
  icon: User,
  color: 'bg-blue-500'
}, {
  id: 'stomp',
  label: '跺脚',
  icon: Footprints,
  color: 'bg-orange-500'
}, {
  id: 'partner',
  label: '对拍',
  icon: Smile,
  color: 'bg-green-500'
}];
export function BodyPercussion() {
  const [activeAction, setActiveAction] = useState<number | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [speed, setSpeed] = useState<'slow' | 'medium' | 'fast'>('medium');
  useEffect(() => {
    let interval: number;
    if (isPlaying) {
      const duration = speed === 'slow' ? 2000 : speed === 'medium' ? 1500 : 1000;
      interval = window.setInterval(() => {
        setActiveAction(prev => {
          if (prev === null) return 0;
          return (prev + 1) % ACTIONS.length;
        });
      }, duration);
    } else {
      setActiveAction(null);
    }
    return () => clearInterval(interval);
  }, [isPlaying, speed]);
  return <div className="flex flex-col items-center w-full max-w-4xl mx-auto" data-id="element-59">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 w-full mb-12" data-id="element-60">
        {ACTIONS.map((action, index) => {
        const isActive = activeAction === index;
        const Icon = action.icon;
        return <div key={action.id} className={`aspect-square rounded-3xl flex flex-col items-center justify-center p-6 transition-all duration-300 ${isActive ? `${action.color} text-white scale-110 shadow-2xl ring-4 ring-offset-4 ring-offset-white ring-${action.color.split('-')[1]}-300` : 'bg-white text-gray-400 shadow-md'}`} data-id="element-61">
              <Icon className={`w-16 h-16 mb-4 ${isActive ? 'animate-bounce' : ''}`} data-id="element-62" />
              <span className="text-2xl font-bold" data-id="element-63">{action.label}</span>
              {isActive && <span className="absolute top-4 right-4 text-4xl opacity-50" data-id="element-64">
                  {index + 1}
                </span>}
            </div>;
      })}
      </div>

      <div className="flex flex-col items-center space-y-6 bg-white p-8 rounded-2xl shadow-lg w-full max-w-xl" data-id="element-65">
        <div className="flex items-center space-x-4" data-id="element-66">
          <span className="text-gray-500 font-medium" data-id="element-67">速度:</span>
          {(['slow', 'medium', 'fast'] as const).map(s => <button key={s} onClick={() => setSpeed(s)} className={`px-4 py-2 rounded-full text-sm font-bold transition-colors ${speed === s ? 'bg-gray-800 text-white' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`} data-id="element-68">
              {s === 'slow' ? '慢速' : s === 'medium' ? '中速' : '快速'}
            </button>)}
        </div>

        <button onClick={() => setIsPlaying(!isPlaying)} className={`w-full py-4 rounded-xl text-xl font-bold text-white shadow-lg transition-transform active:scale-95 ${isPlaying ? 'bg-gray-400' : 'bg-[#177CB0]'}`} data-id="element-69">
          {isPlaying ? '停止练习' : '开始练习'}
        </button>
      </div>
    </div>;
}